export default __webpack_public_path__ + "static/media/history_icon.ff176ce8.svg";